module.exports = __webpack_public_path__ + "img/tbvrent.45035f8c.jpg";